// extracted by mini-css-extract-plugin
export default {"contactSection":"ContactSection_contactSection__8BAqK","title":"ContactSection_title__3jg00","button":"ContactSection_button__1Mit6"};